import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/*
    NOTE:
    This component is ONLY for use with legacy pages which use asp.net full page postbacks.
    For all other pages, use a standard Embark button component
*/
import { Button } from '@emburse/embark-core';
export default function WebFormSubmitButton({ id, onSubmit, value, disabled, label, children }) {
    const submitInputId = `${id}_submit`;
    const submitForm = () => {
        if (onSubmit) {
            onSubmit();
            return;
        }
        const submitButton = document.getElementById(submitInputId);
        submitButton.click();
    };
    return (_jsxs(_Fragment, { children: [_jsx("input", { id: `${id}_submit`, type: "submit", name: "submit", value: value, style: {
                    position: 'absolute',
                    left: '-99999px',
                    visibility: 'hidden'
                } }), _jsxs(Button, { fullWidth: true, id: id, size: "large", disabled: disabled, onClick: submitForm, children: [label, children] })] }));
}
